import { render } from "./About.vue?vue&type=template&id=7afe340a&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=7afe340a&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-7afe340a"

export default script